import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
export function ShopPage() {
  const navigate = useNavigate();
  useEffect(() => {
    // Redirect to the landing page and scroll to the personaliza section
    navigate('/#personaliza', {
      replace: true
    });
  }, [navigate]);
  return <div className="min-h-screen bg-[#0A0A0B] flex items-center justify-center text-white" data-id="element-901">
      <div className="animate-pulse text-gold font-serif italic text-xl" data-id="element-902">
        Cargando...
      </div>
    </div>;
}